import axios from 'axios';
import { getConfig } from '../utils/sessionStorageUtils';
/**
 * @deprecated The method should not be used, use instaLocalIntegration instead
 */
export const instaIntegration = async () => {
  try {
    const response = await axios.get('https://v1.nocodeapi.com/chrono1010prague/instagram/OuDdZROCTNXScvoQ');
    return response.data;
  } catch (e) {
    console.log(e);
  }
};

export const instaLocalIntegration = async () => {
  try {
    const response = await axios.get('/Instagram/get-media', getConfig());
    return response.data;
  } catch (e) {
    console.log(e);
  }
};
